import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/warehouse',
    children: [
      { path: '', redirect: '/warehouse/home' },
      { path: 'home', name: 'warehouse-home', component: () => import('@/modules/warehouse/WarehouseHome.vue') },
      { path: 'raw', name: 'warehouse-raw', component: () => import('@/modules/warehouse/RawAuxCenter.vue') },
      { path: 'finished', name: 'warehouse-finished', component: () => import('@/modules/warehouse/FinishedGoodsCenter.vue') },
      { path: 'transfer', name: 'warehouse-transfer', component: () => import('@/modules/warehouse/StockTransfer.vue') },
      { path: 'dispatch', name: 'warehouse-dispatch', component: () => import('@/modules/warehouse/LogisticsDispatch.vue') },
      { path: 'inventory', name: 'warehouse-inventory', component: () => import('@/modules/warehouse/InventoryList.vue') },
      { path: 'delivery', name: 'warehouse-delivery', component: () => import('@/modules/warehouse/DeliveryManage.vue') }
    ]
  }
]

export default routes
